import React, { useEffect } from 'react';
import Contact from '../components/Contact';

const KontaktPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-24 md:pt-32 steel-bg">
      <Contact />
    </div>
  );
};

export default KontaktPage;
